import { render } from "./WithdrawalPasswordSetReset.vue?vue&type=template&id=07a49eea&scoped=true"
import script from "./WithdrawalPasswordSetReset.vue?vue&type=script&lang=js"
export * from "./WithdrawalPasswordSetReset.vue?vue&type=script&lang=js"

import "./WithdrawalPasswordSetReset.vue?vue&type=style&index=0&id=07a49eea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a49eea"]])

export default __exports__